import { render, staticRenderFns } from "./CompilatoreRicognizione.vue?vue&type=template&id=0bbd986a"
import script from "./CompilatoreRicognizione.vue?vue&type=script&lang=js"
export * from "./CompilatoreRicognizione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports